const tooltipPosition = (point, params, dom, rect, size) => {
  const obj = { top: 20 };

  const GAP = 20;
  const x = point[0];
  if ((x + size.contentSize[0] + GAP) < size.viewSize[0]) {
    obj.left = x + 20;
  } else {
    obj.left = 'auto';
    obj.right = (size.viewSize[0] - x) + 20;
  }

  return obj;
};

export default tooltipPosition;
